import type { FrameContractDTO } from "@jobrad-gmbh/bike-leasing-calculator";

export const fetchFrameContractData = async (
  url: string,
  headers: Record<string, string> | undefined = undefined,
): Promise<FrameContractDTO> => {
  const response = await fetch(url, {
    method: "GET",
    headers,
  });

  if (response.ok) {
    const json = await response.json();
    if (json) {
      return json;
    } else {
      throw new Error(`Empty data returned from url: ${url}`);
    }
  } else {
    throw new Error(`Request failed with error code ${response.status} from ${url}`);
  }
};

export const isServiceMandatory = (frameContract: FrameContractDTO): boolean =>
  frameContract.bike_services.is_mandatory;

export const isCompanyServicePayer = (frameContract: FrameContractDTO): boolean =>
  frameContract.bike_services.payer.value === "company";

export const hasMultipleServiceOptions = (frameContract: FrameContractDTO): boolean =>
  frameContract.bike_services.leasing_options.length > 1;
